import { useEffect, useState } from 'react'
import './nameDialog.css'
import { WooNotesButton, WooNotesButtonColor, WooNotesButtonSize } from '../WooNotes/WooNotesButton'
import { WooNotesErrorAlert } from '../WooNotes/WooNotesErrorAlert'

type Props = {
  errorMsg: string | undefined
  onClose: () => void
}

export const ErrorDialog = ({ errorMsg, onClose }: Props) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (!errorMsg) return

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }

    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [errorMsg, onClose])

  if (!errorMsg) return null

  return (
    <div className="dialog-root">
      <div className="dialog-backdrop" onClick={onClose} />

      <div className="dialog">
        <WooNotesErrorAlert title="" message={errorMsg} shadowColor="black"></WooNotesErrorAlert>

        <div className="actions">
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.Red} onClick={onClose}>
            Close
          </WooNotesButton>
        </div>
      </div>
    </div>
  )
}
